/* eslint-disable no-unused-vars */
window.ScrollLock = require('./util/scrollLock');

import './modules/navigation/main';
import './modules/form/select';
import './modules/carousel/carousel.default';
import './modules/aos/aos.default';

window.addEventListener('load', () => {
    const html = document.querySelector('html')
    html.classList.remove('preload')
});



// WEBPACK FOOTER //
// ./js/main.js